"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEmpty = void 0;

var isEmpty = function isEmpty(object) {
  if (object == null) {
    return true;
  }

  if (typeof object === 'object') {
    return !Object.keys(object).length;
  }

  return true;
};

exports.isEmpty = isEmpty;